const getDevicedId = () => {
  var key = "nfplus_deviceid"
  function guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0
      var v = c == "x" ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
  function isLocalStorageSupported() {
    var testKey = "localstorage_support_test"
    var storage = window.sessionStorage
    try {
      storage.setItem(testKey, "testValue")
      storage.removeItem(testKey)
      return true
    } catch (error) {
      return false
    }
  }
  if (isLocalStorageSupported()) {
    var deviceid = window.localStorage.getItem(key) || ""
    if (deviceid == "") {
      deviceid = guid()
      window.localStorage.setItem(key, deviceid)
    }
    return deviceid
  } else {
    return guid()
  }
}

export default getDevicedId
